import { Css } from "@homebound/beam";

export function Footer() {
  return (
    <div css={Css.pt3.pb2.asfe.ifSm.asc.$}>
      <div css={Css.sm.gray700.$}>© Homebound Technologies, Inc. {new Date().getFullYear()}</div>
    </div>
  );
}
